<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              :page-id="this.$options.name"
              :selected-md="searchBox.moduleCode"
              :selected-smd="searchBox.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MNTR_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              :selected="searchBox.taskMonitoringCycleTypeCode"
              codeId="COD_TASK_MNTR_CYCL_TYPE"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.taskMonitoringTypeName"
              placeholder=""
              default
              value
              :disabled="false"
              :clearable="true"
              :readonly="false"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsTaskMonitoringType'"
        :multiselect="multiselect"
        :showDisplayCountControl="false"
        :initialPagesize="5"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ this.$t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelect"
        >
          {{ this.$t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMS_00014', // eslint-disable-line vue/name-property-casing
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      multiselect: false,

      searchBox: {
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        taskMonitoringCycleTypeCode: { key: '', label: '' },
        taskMonitoringTypeName: '',
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_TASK_MNTR_TYPE_NM'),
        datafield: 'taskMonitoringTypeName',
      }, {
        text: this.$t('MSG_TXT_MNTR_PRD'),
        datafield: 'taskMonitoringCycleTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement,
            {
              displayType: '1', // "1", "2" - default: "1"
              type: 'sublink', // 'link', 'sublink' - default: "link"
            }, this.dsTaskMonitoringType, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
        width: '150px',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsTaskMonitoringType, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsTaskMonitoringType',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'taskMonitoringTypeUID',
      type: 'string',
      map: 'taskMonitoringTypeUID',
    }, {
      name: 'moduleCode',
      type: 'string',
      map: 'moduleCode',
    }, {
      name: 'moduleName',
      type: 'string',
      map: 'moduleName',
    }, {
      name: 'subModuleCode',
      type: 'string',
      map: 'subModuleCode',
    }, {
      name: 'subModuleName',
      type: 'string',
      map: 'subModuleName',
    }, {
      name: 'taskMonitoringTypeName',
      type: 'string',
      map: 'taskMonitoringTypeName',
    }, {
      name: 'taskMonitoringCycleTypeCode',
      type: 'string',
      map: 'taskMonitoringCycleTypeCode',
    }, {
      name: 'taskMonitoringCycleTypeName',
      type: 'string',
      map: 'taskMonitoringCycleTypeName',
    }, {
      name: 'firstRegistrationUserId',
      type: 'string',
      map: 'firstRegistrationUserId',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }],
  }],
  mounted() {
    if (this.pageInitialData.multiselect) {
      this.multiselect = true;
    } else {
      this.multiselect = false;
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      this.searchTaskMonitoringType();
    },
    onSelect() {
      this.selectedTaskMonitoringType();
    },
    onCancel() {
      this.cancel();
    },

    /** ***************************************************************************
        함수 영역 : 사용자 정의 함수
      ***************************************************************************** */
    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });

      this.searchBox.moduleCode.key = 'ALL';
      this.searchBox.subModuleCode.key = 'ALL';
      this.searchBox.taskMonitoringCycleTypeCode.key = 'ALL';
    },

    searchTaskMonitoringType() {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.$options.name, 'DTS_CMS_00026', {
        query: queryParams,
      }).then(res => {
        console.log(res);
        this.dsTaskMonitoringType.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },

    selectedTaskMonitoringType() {
      const selectedRawsData = this.dsTaskMonitoringType.getSelectedRawData();
      if (selectedRawsData.length <= 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }

      this.closePagePopup(selectedRawsData);
      return true;
    },

    cancel() {
      this.closePagePopup('');
    },
  },
};
</script>
<style scoped>
</style>
